var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 341,
    viewBox: "0 0 243 341",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.563 48.2549L149.278 12.5394C142.929 16.1677 137.056 20.4989 131.727 25.4197L126.443 30.7033C121.522 36.0096 117.191 41.9055 113.563 48.2549Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.905 76.6469L177.669 1.88232C175.606 2.2905 173.565 2.78938 171.547 3.33362L104.356 70.5242C103.789 72.5424 103.313 74.5834 102.905 76.6469Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 95.6497C101 95.8538 101 96.0578 101 96.2619L197.262 0C197.058 0 196.854 0 196.65 0C195.266 0 193.883 0.0453379 192.5 0.0906909L101.091 91.4998C101.045 92.8831 101 94.2437 101 95.6497Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.497 112.498L213.544 1.45074C212.206 1.22397 210.845 0.997208 209.507 0.815796L101.884 108.439C102.043 109.822 102.247 111.16 102.497 112.498Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.125 126.603L227.626 5.10233C226.447 4.69416 225.267 4.33133 224.088 3.96851L105.014 123.043C105.354 124.245 105.717 125.424 106.125 126.603Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.408 139.053L240.098 10.3632C239.055 9.84164 238.012 9.32008 236.946 8.84387L109.866 135.901C110.365 136.966 110.864 138.009 111.408 139.053Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.03 150.141L251.164 17.0072C250.234 16.3722 249.305 15.7373 248.375 15.125L116.171 147.329C116.783 148.282 117.395 149.211 118.03 150.141Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.899 160.005L261.028 24.8755C260.212 24.1272 259.373 23.4016 258.534 22.6986L123.699 157.533C124.425 158.372 125.15 159.189 125.899 160.005Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.924 168.714L269.736 33.9015C269.033 33.0625 268.307 32.2235 267.559 31.4071L132.43 166.537C133.246 167.285 134.085 168.011 134.924 168.714Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.129 176.242L277.287 44.0832C276.675 43.1308 276.063 42.2011 275.405 41.2941L142.317 174.383C143.246 175.018 144.176 175.653 145.129 176.242Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.58 182.523L283.546 55.557C283.047 54.4912 282.548 53.4482 282.027 52.405L153.428 181.004C154.471 181.525 155.514 182.024 156.58 182.523Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.461 187.376L288.422 68.438C288.059 67.2361 287.696 66.0569 287.31 64.9004L165.923 186.288C167.079 186.651 168.259 187.014 169.461 187.376Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.064 190.483L291.506 83.0415C291.324 81.6809 291.12 80.343 290.893 78.9824L180.028 189.848C181.366 190.097 182.703 190.302 184.064 190.483Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.672 191.322C198.146 191.322 199.62 191.276 201.071 191.208L292.231 100.049C292.299 98.5973 292.345 97.1234 292.345 95.6495C292.345 95.5361 292.345 95.4 292.345 95.2866L196.332 191.299C196.423 191.299 196.559 191.322 196.672 191.322Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.138 187.876L288.898 121.116C289.465 119.098 289.964 117.034 290.372 114.971L215.97 189.372C218.056 188.942 220.12 188.443 222.138 187.876Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34583 190.782L32.0728 167.055C27.8546 169.465 23.9529 172.343 20.4127 175.612L16.9026 179.122C13.6335 182.647 10.7562 186.564 8.34583 190.782Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.26538 209.644L50.9338 159.975C49.5629 160.246 48.2071 160.578 46.8663 160.939L2.22954 205.576C1.85293 206.917 1.53655 208.273 1.26538 209.644Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 222.268C0 222.403 0 222.539 0 222.674L63.9497 158.725C63.8141 158.725 63.6786 158.725 63.543 158.725C62.624 158.725 61.7051 158.755 60.7861 158.785L0.0602258 219.511C0.0300963 220.43 0 221.334 0 222.268Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.994179 233.46L74.7661 159.689C73.8773 159.538 72.9734 159.387 72.0846 159.267L0.587402 230.764C0.692855 231.683 0.828467 232.572 0.994179 233.46Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.40454 242.831L84.1213 162.114C83.338 161.843 82.5546 161.602 81.7712 161.361L2.66638 240.466C2.89235 241.264 3.13337 242.048 3.40454 242.831Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91465 251.101L92.4069 165.609C91.714 165.263 91.021 164.916 90.3129 164.6L5.89026 249.007C6.22168 249.715 6.5531 250.408 6.91465 251.101Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3135 258.468L99.7585 170.023C99.1408 169.601 98.5232 169.179 97.9056 168.773L10.0782 256.6C10.485 257.233 10.8917 257.85 11.3135 258.468Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.541 265.021L106.312 175.25C105.769 174.753 105.212 174.271 104.655 173.804L15.0797 263.379C15.5618 263.936 16.0439 264.479 16.541 265.021Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5367 270.806L112.097 181.246C111.63 180.689 111.147 180.132 110.65 179.589L20.8796 269.36C21.422 269.857 21.9793 270.339 22.5367 270.806Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3159 275.807L117.113 188.01C116.706 187.378 116.3 186.76 115.863 186.157L27.4479 274.572C28.0655 274.994 28.6832 275.416 29.3159 275.807Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9235 279.98L121.271 195.633C120.94 194.925 120.608 194.232 120.262 193.539L34.8296 278.971C35.5226 279.317 36.2155 279.649 36.9235 279.98Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4804 283.205L124.51 204.19C124.269 203.392 124.028 202.608 123.772 201.84L43.1302 282.481C43.8985 282.722 44.682 282.964 45.4804 283.205Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.182 285.268L126.559 213.892C126.438 212.988 126.303 212.099 126.152 211.195L52.5005 284.847C53.3893 285.012 54.2781 285.148 55.182 285.268Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.558 285.826C64.5372 285.826 65.5164 285.796 66.4805 285.75L127.041 225.19C127.086 224.226 127.116 223.247 127.116 222.268C127.116 222.192 127.116 222.102 127.116 222.027L63.332 285.811C63.3923 285.811 63.4827 285.826 63.558 285.826Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4757 283.536L124.826 239.186C125.203 237.845 125.534 236.474 125.805 235.103L76.3781 284.53C77.764 284.244 79.1349 283.913 80.4757 283.536Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.544 254.144L95.4349 277.254C105.001 271.695 112.985 263.71 118.544 254.144Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.501 290.313L145.154 277.66C142.905 278.945 140.824 280.48 138.936 282.223L137.064 284.095C135.321 285.975 133.786 288.064 132.501 290.313Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.725 300.372L155.213 273.884C154.482 274.029 153.759 274.205 153.044 274.398L129.239 298.203C129.038 298.918 128.869 299.641 128.725 300.372Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.05 307.104C128.05 307.177 128.05 307.249 128.05 307.321L162.155 273.217C162.082 273.217 162.01 273.217 161.938 273.217C161.448 273.217 160.957 273.233 160.467 273.249L128.082 305.634C128.066 306.124 128.05 306.606 128.05 307.104Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.58 313.074L167.923 273.731C167.449 273.65 166.967 273.57 166.493 273.506L128.363 311.635C128.42 312.126 128.492 312.6 128.58 313.074Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.866 318.071L172.912 275.024C172.494 274.88 172.077 274.751 171.659 274.622L129.472 316.809C129.593 317.235 129.721 317.653 129.866 318.071Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.738 322.481L177.331 276.888C176.961 276.703 176.592 276.518 176.214 276.35L131.191 321.364C131.368 321.742 131.545 322.112 131.738 322.481Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.084 326.41L181.251 279.242C180.922 279.017 180.593 278.792 180.263 278.576L133.425 325.414C133.642 325.751 133.859 326.081 134.084 326.41Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.871 329.905L184.746 282.03C184.457 281.765 184.16 281.508 183.863 281.259L136.092 329.029C136.349 329.327 136.606 329.616 136.871 329.905Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.069 332.99L187.831 285.228C187.582 284.93 187.325 284.633 187.06 284.344L139.185 332.219C139.474 332.484 139.772 332.741 140.069 332.99Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.684 335.657L190.507 288.835C190.29 288.498 190.073 288.168 189.84 287.847L142.688 334.999C143.017 335.224 143.347 335.449 143.684 335.657Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.741 337.883L192.724 292.9C192.547 292.523 192.371 292.153 192.186 291.784L146.625 337.345C146.994 337.529 147.364 337.706 147.741 337.883Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.305 339.602L194.451 297.464C194.323 297.038 194.194 296.62 194.058 296.21L151.052 339.217C151.461 339.345 151.879 339.474 152.305 339.602Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.479 340.703L195.544 302.638C195.48 302.156 195.408 301.682 195.327 301.2L156.049 340.478C156.523 340.567 156.997 340.639 157.479 340.703Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.946 341C162.468 341 162.99 340.984 163.504 340.96L195.801 308.663C195.825 308.149 195.841 307.626 195.841 307.104C195.841 307.064 195.841 307.016 195.841 306.976L161.825 340.992C161.857 340.992 161.905 341 161.946 341Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.968 339.779L194.62 316.127C194.821 315.412 194.998 314.681 195.142 313.95L168.783 340.309C169.522 340.157 170.253 339.98 170.968 339.779Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.27 324.104L178.946 336.429C184.047 333.464 188.305 329.206 191.27 324.104Z",
    fill: "#4643C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 243,
    height: 341,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.8c9c1861b9f4ecf0ea7483d39dc27af3.svg";
export { ForwardRef as ReactComponent };